module.exports = __webpack_public_path__ + "img/excel.dc8099d9.svg";